export enum TableColumnIdEnums {
  NAME = 'name',
  EMAIL = 'email',
  CITY = 'city',
  ZIPCODE = 'zipCode',
}
